import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { updateMOP } from './PaymentState.actions';
import { transformUpdateMopPayload } from './helpers/transformUpdateMopPayload';
import API from '../../api';
import { handleUpdateMopAPIFailure } from './helpers/handleUpdateMopAPIFailure';
import { handleUpdateMopError } from './helpers/handleUpdateMopError';
import { handleUpdateMopSuccess } from './helpers/handleUpdateMopSuccess';
var UpdateMopLogic = function UpdateMopLogic(middleware) {
  return middleware.startListening({
    actionCreator: updateMOP,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
        var payload, getState, dispatch, transformPayload, state, appMode, config, goBackMode, rioNamespace, paymentForm, updateMopPayload, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload;
              getState = _ref2.getState, dispatch = _ref2.dispatch;
              transformPayload = transformUpdateMopPayload(payload, getState());
              state = getState();
              appMode = state.appMode, config = state.config;
              goBackMode = appMode.goBackMode;
              rioNamespace = config.rioNamespace, paymentForm = config.paymentForm;
              updateMopPayload = _objectSpread({}, transformPayload);
              _context.next = 10;
              return API.updateMop(updateMopPayload);
            case 10:
              response = _context.sent;
              if (!response.data) {
                handleUpdateMopAPIFailure({
                  response: response,
                  dispatch: dispatch,
                  rioNamespace: rioNamespace
                });
              }
              //data error from updateMop API
              else if (!response.data.mopV2) {
                handleUpdateMopError({
                  response: response,
                  dispatch: dispatch,
                  rioNamespace: rioNamespace
                });
              }
              //Successful call to updateMop API
              else {
                handleUpdateMopSuccess({
                  response: response,
                  dispatch: dispatch,
                  state: state,
                  goBackMode: goBackMode,
                  paymentForm: paymentForm
                });
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default UpdateMopLogic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/UpdateMop.listener.js
// module id = 4396
// module chunks = 11